<template>
  <FacetTagButton>
    <span>{{ $t('price', { from: values[0], to: values[1], currency }) }}</span>
  </FacetTagButton>
</template>

<script setup lang="ts">
defineComponent({
  name: 'FacetTagPrice',
});
const { t: $t } = useI18n({
  useScope: 'local',
});

const props = withDefaults(
  defineProps<{
    label?: string;
    value: [number, number];
  }>(),
  {
    label: '',
  },
);
const values = computed(() => {
  return [props.value?.[0], props.value?.[1]];
});

const currency = inject(CONFIG_STORE_CURRENCY);
</script>

<style lang="postcss" scoped>
.facet-items + .facet-items {
  @apply ml-4;
}

span {
  text-align: start;
}
</style>
<i18n>
{
  "en": {
    "price": "{from}{currency} - {to} {currency}"
  },
  "ar": {
      "price": "{to} {currency} - {from}{currency}"
  }
}
</i18n>
